import { render, staticRenderFns } from "./FormWallet.vue?vue&type=template&id=1fe09b4d&"
import script from "./FormWallet.vue?vue&type=script&lang=js&"
export * from "./FormWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports